import React from 'react';
import MenuSkeleton from './skeletons/MenuSkeleton';

// Keep GlobalLoader for backward compatibility but use MenuSkeleton by default
// Individual pages can override this by using their specific skeleton components
const GlobalLoader: React.FC = () => <MenuSkeleton />;

export default GlobalLoader; 